<template>
  <div class="change">
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-icon color="lime" v-on="on">
          icon-change
        </v-icon>
      </template>
      <span>{{ $t("message.externalChanges.changeTooltip") }}</span>
    </v-tooltip>
    <div class="change__container">
      <div class="change__wrapper">
        <div>
          <p class="field-name"><slot name="field"></slot></p>
        </div>
        <slot></slot>
        <div
          v-if="this.$slots.old || this.$slots.new"
          class="d-flex"
          :class="{ 'flex-column': vertical }"
        >
          <div
            v-if="this.$slots.old"
            class="before"
            :class="{ 'before--vertical': vertical }"
          >
            <small>{{ $t("message.common.before") }}</small>
            <slot name="old"></slot>
          </div>
          <div
            v-if="this.$slots.new"
            class="after"
            :class="{ 'after--vertical': vertical }"
          >
            <small>{{ $t("message.common.after") }}</small>
            <slot name="new"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GeneralChange",
  props: {
    vertical: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.change {
  display: flex;
  align-items: flex-start;

  & > i {
    margin-right: $spacing * 3;
  }

  & p {
    margin-bottom: 0;
    line-height: 24px;
  }

  &__wrapper {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  &__container {
    display: flex;
    flex: 1;
  }

  .field-name {
    @include font-size(14px);
    opacity: 0.6;
    margin-bottom: $spacing * 0.5;
  }
}

.before,
.after {
  padding-right: $spacing * 3;
  max-width: 50%;
  flex: 1;

  &--vertical {
    max-width: 100%;
  }

  p {
    margin-bottom: 0;
  }

  small {
    opacity: 0.6;
  }
}

.before {
  position: relative;

  &:after,
  &:before {
    position: absolute;
    content: " ";
    width: 1px;
    height: 50%;
    bottom: 0px;
  }

  &:before {
    position: absolute;
    right: 0;
    height: 100%;
    width: 1px;
    background-color: $gray-300;
  }

  &:after {
    display: inline-block;
    position: absolute;
    top: calc(50% - 8px);
    right: -1px;
    height: 10px;
    width: 10px;
    transform: rotate(135deg) translateY(-50%);
    border-top: 1px solid $gray-300;
    border-left: 1px solid $gray-300;
    background-color: $light-4;
  }

  &--vertical {
    padding-bottom: $spacing * 2;
    margin-bottom: $spacing * 2;

    &:after,
    &:before {
      position: absolute;
      content: " ";
      height: 1px;
      width: 50%;
      bottom: 0px;
    }

    &:before {
      position: absolute;
      right: 0;
      width: 100%;
      height: 1px;
      background-color: $gray-300;
    }

    &:after {
      display: inline-block;
      position: absolute;
      left: calc(50% - 8px);
      top: calc(100% - 8px);
      height: 10px;
      width: 10px;
      transform: rotate(-135deg) translateY(-50%);
      border-top: 1px solid $gray-300;
      border-left: 1px solid $gray-300;
      background-color: $light-4;
    }
  }
}

.after {
  padding-left: $spacing;
  margin-left: $spacing * 2;

  &--vertical {
    padding-left: 0;
    margin-left: 0;
  }
}

.opening-hours {
  .change {
    &__wrapper {
      flex: unset;
    }
  }
}
</style>
